import React, { useState } from "react";
import BotonAumentar from "../../../../componentsUI/formularios/button/ButtonAumentar.js";
import BotonDisminuir from "../../../../componentsUI/formularios/button/ButtonDisminuir.js";
import "../../../../componentsUI/formularios/button/Button.css";


export default function BotoneraMasMenosCard({
  cantidadInicial = 0,
  onCantidadChange
}) {
  const [cantidad, setCantidad] = useState(cantidadInicial);

  const aumentar = () => {
    const nueva = cantidad + 1;
    setCantidad(nueva);
    onCantidadChange?.(nueva);
  };

  const disminuir = () => {
    const nueva = Math.max(cantidad - 1, 0);
    setCantidad(nueva);
    onCantidadChange?.(nueva);
  };

  return (
    <div className="botonera-uix">
      <BotonDisminuir onSelect={disminuir} />
      <span className="contador">{cantidad}</span>
      <BotonAumentar onSelect={aumentar} />
    </div>
  );
}
